export const PAGINATION = {
  page: 1,
  size: 10,
}

export const TASK_BELONG = {
  NEW_USER_TASK: 'NEW_USER_TASK',
  LIMITED_TIME_TASK: 'LIMITED_TIME_TASK',
}

export const TASK_BELONG_OPTIONS = [
  { label: '全部', value: '' },
  { label: '新人任务', value: TASK_BELONG.NEW_USER_TASK },
  { label: '限时任务', value: TASK_BELONG.LIMITED_TIME_TASK },
]

export const TASK_BELONG_FORM_OPTIONS = TASK_BELONG_OPTIONS.filter((i) => i.value)

export const TASK_TYPE = {
  SINGLE_RULE: 'SINGLE_RULE',
  CHECK_IN: 'CHECK_IN',
  CUMULATIVE: 'CUMULATIVE',
}

export const TASK_TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '单规则', value: TASK_TYPE.SINGLE_RULE },
  { label: '打卡型', value: TASK_TYPE.CHECK_IN },
  { label: '累计型', value: TASK_TYPE.CUMULATIVE },
]

export const TASK_TYPE_FORM_OPTIONS = [
  { label: '单规则任务', value: TASK_TYPE.SINGLE_RULE },
  { label: '打卡型任务', value: TASK_TYPE.CHECK_IN },
  { label: '累计型任务', value: TASK_TYPE.CUMULATIVE },
]

export const TASK_LEVEL_OPTIONS = [
  { label: '基础任务', value: 'BASIC' },
  { label: '进阶任务', value: 'ADVANCED' },
]

export const TASK_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  EXPIRED: 'EXPIRED',
  OFFLINE: 'OFFLINE',
}

export const TASK_STATUS_OPTIONS = [
  { label: '全部', value: '' },
  { label: '未开始', value: TASK_STATUS.NOT_STARTED },
  { label: '进行中', value: TASK_STATUS.IN_PROGRESS },
  { label: '已过期', value: TASK_STATUS.EXPIRED },
  { label: '已下线', value: TASK_STATUS.OFFLINE },
]

/** 列表状态标签：type 对应 el-tag */
export const TASK_STATUS_TAG = {
  [TASK_STATUS.NOT_STARTED]: { text: '未开始', type: 'info' },
  [TASK_STATUS.IN_PROGRESS]: { text: '进行中', type: 'success' },
  [TASK_STATUS.EXPIRED]: { text: '已过期', type: 'danger' },
  [TASK_STATUS.OFFLINE]: { text: '已下线', type: 'info' },
}

export const COMPLETE_RULE = {
  REGISTER: 'REGISTER',
  KYC: 'KYC',
  FIRST_DEPOSIT: 'FIRST_DEPOSIT',
  FIRST_CONTRACT_TRADE: 'FIRST_CONTRACT_TRADE',
}

export const COMPLETE_RULE_OPTIONS = [
  { label: '注册', value: COMPLETE_RULE.REGISTER },
  { label: '实名认证', value: COMPLETE_RULE.KYC },
  { label: '首次充值', value: COMPLETE_RULE.FIRST_DEPOSIT },
  { label: '首次合约交易', value: COMPLETE_RULE.FIRST_CONTRACT_TRADE },
]

export function needConditionAmount(ruleType) {
  return (
    ruleType === COMPLETE_RULE.FIRST_DEPOSIT ||
    ruleType === COMPLETE_RULE.FIRST_CONTRACT_TRADE
  )
}

export const RECEIVE_MODE_OPTIONS = [
  { label: '自动下发', value: 'AUTO' },
  { label: '手动领取', value: 'MANUAL' },
]

export const REWARD_GRANT_MODE_OPTIONS = [
  { label: '自动发放', value: 'AUTO' },
  { label: '手动领取', value: 'MANUAL' },
]

export const COUPON_QUANTITY_OPTIONS = [
  { label: '不限', value: 'UNLIMITED' },
]

export const LANG_OPTIONS = [
  { label: '中文', value: 'zh' },
  { label: '英文', value: 'en' },
  { label: '繁体中文', value: 'hk' },
  { label: '越南语', value: 'vi' },
]

export function createEmptyI18n(language = 'zh') {
  return {
    language: normalizeLang(language),
    title: '',
    brief: '',
    ruleDesc: '',
  }
}

/** 接口/历史数据可能为 zh_CN、en_US，统一为 zh、en */
export function normalizeLang(lang) {
  if (!lang) {
    return 'zh'
  }
  const value = String(lang).toLowerCase().replace('-', '_')
  if (value === 'zh' || value === 'zh_cn') {
    return 'zh'
  }
  if (value === 'en' || value === 'en_us') {
    return 'en'
  }
  return lang
}
